const state = {
  sessionTimeoutModalStatus: false,
  defaultLanguages: ['en', 'de', 'es', 'fr', 'enpam', 'esp01bus', 'esp02med', 'esp03leg', 'esp04aca', 'esp05tou', 'esp06it', 'esp07tec', 'esp08cat', 'esp09eng', 'esp10vet'],
};

export default state;
